export default {
  'share.whatsapp.tip': 'WhatsApp might not be installed on your phone, install it and try agian.',
  'share.ok': 'OK',
  'share.install': 'Install Soundi Radio APP Now',
  'share.download': 'Download',
  'share.play': 'Play on Soundi Radio',
  'share.live': 'Live'
};
